import { render } from "./Footer.vue?vue&type=template&id=47a182bb"
const script = {}

import exportComponent from "C:\\xampp\\htdocs\\german\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__